import React, {Component} from 'react'
import {observer} from 'mobx-react'
import classNames from 'classnames'

import Checkbox from 'lib/control/Checkbox'

import styles from './ProfileCatalogStocksSelect.less'

@observer export default class ProfileCatalogStocksSelect extends Component {
    constructor(props) {
        super(props)
        if (props.campaign.catalog_stock_ids) {
            this.state = {
                catalog_stock_ids: props.campaign.catalog_stock_ids
            }
        } else {
            this.state = {
                catalog_stock_ids: []
            }
        }
    }

    render() {
        /** @type {SettingsContext} */
        const context = this.props.context

        return (
            <div>
                { context.stocks
                    .filter(stock => !stock.is_virtual)
                    .map(stock => (
                        <Checkbox
                            key={stock.id}
                            checked={this.state.catalog_stock_ids.includes(stock.id)}
                            onChange={e => this.toggleStock(stock.id, e.target.checked)}
                            labelClassName={classNames({
                                [styles['stock-label_virtual']]: stock.is_virtual,
                            })}
                        >
                            <span>{stock.name}</span>
                        </Checkbox>
                    ))
                }
            </div>
        )
    }

    toggleStock = (stock_id, toggle) => {

        const profile = this.state

        if (toggle) {
            profile.catalog_stock_ids.push(stock_id)
        } else {
            profile.catalog_stock_ids = profile.catalog_stock_ids.filter(id => id !== stock_id)
        }

        this.setState({catalog_stock_ids: profile.catalog_stock_ids})
        this.props.campaign.catalog_stock_ids = profile.catalog_stock_ids
    }
}
